import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取当前租户增值服务通道配置
export function getConfigForCurrentTenant() {
  return request({
    url: URL.sys.getConfigForCurrentTenantUrl,
    method: 'post'
  })
}

// 获取配置全部数据
export function getVasChannelList(data) {
  return request({
    url: URL.sys.getVasChannelListUrl,
    method: 'post',
    data
  })
}

// 保存配置
export function saveVasChannelFunc(data) {
  return request({
    url: URL.sys.saveVasChannelConfigUrl,
    method: 'post',
    data
  })
}

// 删除配置
export function deleteVasChannelFunc(data) {
  return request({
    url: URL.sys.deleteVasChannelConfigUrl,
    method: 'post',
    data
  })
}
